export default "__VITE_ASSET__C8$A5sXR__"